import { get } from 'lodash'

import bynderDATLoader from './bynderDATLoader'
import getBynderDATSrc from './getBynderDATSrc'


export const getOgImage = (imageData) => {
  const bynderId = get(imageData, 'value.image.bynder', '')
  const bynderName = get(imageData, 'value.image.data.name', '')

  // use pre-defined width and height for og:image
  return bynderDATLoader({
    src: getBynderDATSrc({ id: bynderId, name: bynderName }),
    maxWidth: 800,
    width: 800,
    maxHeight: 533,
  })
}
